import {useEffect} from 'react';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {logoutUser} from '../../store/actions';

const Logout = ({logoutUser}) => {
  const navigate = useNavigate();

  useEffect(() => {
    logoutUser();
    navigate('/login');
  }, [logoutUser, navigate]);

  return null;
};

export default connect(
    null,
    {logoutUser},
)(Logout);
